import { REGEX_INDEXED_LEGAL, REGEX_INDEXED_LEGAL_WHOLE, REGEX_NON_INDEXED_LEGAL } from './constants';
/**
 * Splits a string into an array containing a mix of regular text and legal keys.
 *
 * @param str String content including legal keys.
 * @returns An array containing a mix of regular text and legal keys.
 */
export default function splitLegalContent(str) {
    // TODO: This code was copied from eshop legals. It doesn't provide an
    // indicator where a non-indexed legal was. Is it supposed to?
    const textArray = str.replace(REGEX_NON_INDEXED_LEGAL, '').split(REGEX_INDEXED_LEGAL_WHOLE);
    const indexedLegals = [...str.matchAll(REGEX_INDEXED_LEGAL)];
    const result = [];
    for (let i = 0; i < textArray.length; i++) {
        result.push(textArray[i]);
        if (indexedLegals[i]) {
            // Add the entire index token ${LEGAL.slug} which is at position 0.
            result.push(indexedLegals[i][0]);
        }
    }
    return result;
}
